export const clientTypes = {
  carrier: 'carrier',
  driver: 'driver',
  microHub: 'microhub',
  shipper: 'shipper',
  vehicle: 'vehicle',
};
